import React, {useEffect, useRef, useState} from 'react';
import {Button, Form, Input} from "antd";
import {toast} from "react-toastify";
import OtpInput from "react-otp-input";
import axios from "axios";
import {ApiNameGrant} from "../APIname";

function ModalForma(props) {
    const [token] = useState(JSON.parse(localStorage.getItem("myCat")));
    const [fulInfo, setFulInfo] = useState(props?.user)
    const formRef = useRef(null);
    const inputRef = useRef(null);
    const [form] = Form.useForm();
    const [form2] = Form.useForm();
    const [otp, setOtp] = useState('');
    const [verificatio, setVerificatio] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            inputRef.current?.focus();
        }, 100); // biroz kechiktirish bilan
    }, [props?.handleCancel]);

        function handleOk() {
        if (form.getFieldValue('Tel')?.length > 12) {
            axios.post(`${ApiNameGrant}/api/v1`, {
                currentPaymentFormStatus:
                    fulInfo?.paymentFormInfo?.name === "To‘lov-shartnoma" ? "CONTRACT" :
                        fulInfo?.paymentFormInfo?.name === "Davlat granti" ? "FULL_TUITION_GRANT" : "PARTIAL_TUITION_GRANT",
                education_year_info: fulInfo?.education_year_info,
                levelInfo: fulInfo?.levelInfo,
                studentIdNumber: fulInfo?.profile_id_number,
                phone: form.getFieldValue('Tel'),
            }, {
                ContentType: "application/json",
                headers: {"Authorization": `Bearer ${token}`,"ngrok-skip-browser-warning": "true",}
            }).then((response) => {
                console.log("Response:", response);
                if (response?.status === 201) {
                    setVerificatio(true)
                } else {
                    toast.error("Xatolik yuz berdi, qayta urinib ko'ring!");
                }
            }).catch((error) => {
                console.error(error);
                toast.error(error?.response?.data?.message);
            })
        } else {
            toast.error("Telefon raqami noto'g'ri kiritildi!");
        }
    }
    function verificationPost() {
        if (otp.length === 6) {
            setLoading(true);
            const delay = new Promise(resolve => setTimeout(resolve, 2000)); // 2s delay

            const request = axios.post(`${ApiNameGrant}/verify-otp`, {
                phone: form.getFieldValue('Tel'),
                code: otp,
            }, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "ngrok-skip-browser-warning": "true",
                }
            });

            Promise.all([request, delay])
                .then(([response]) => {
                    console.log(response);
                    if (response?.data?.isSuccess === true) {
                        setVerificatio(false);
                        form2.resetFields();
                        props?.handleCancel();
                        form.resetFields();
                        setOtp('');
                        toast.success("Davlat grantini qayta taqsimlashda ishtirok etish uchun arizangiz qabul qilindi.");
                    } else {
                        toast.warning(response?.data?.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    toast.error("Xatolik yuz berdi.");
                })
                .finally(() => {
                    setLoading(false); // 2s tugagach loading o‘chadi
                });
        } else {
            toast.warning("Tasdiqlash kodini to'liq kiriting");
        }
    }

    // function verificationPost() {
    //     if (otp.length === 6) {
    //         setLoading(true);
    //         axios.post(`${ApiNameGrant}/verify-otp`, {
    //                 phone: form.getFieldValue('Tel'),
    //                 code: otp,
    //             },
    //             {
    //                 headers: {"Authorization": `Bearer ${token}`,"ngrok-skip-browser-warning": "true",}
    //             })
    //             .then((response) => {
    //             console.log(response)
    //             if (response?.data?.isSuccess === true) {
    //                 setVerificatio(false)
    //                 form2.resetFields()
    //                 props?.handleCancel()
    //                 form.resetFields();
    //                 setOtp('')
    //                 toast.success("Davlat grantini qayta taqsimlashda ishtirok etish uchun arizangiz qabul qilindi.")
    //             } else {
    //                 toast.warning(response?.data?.message)
    //             }
    //         }).catch((error) => {
    //             console.log(error);
    //
    //         }).finally(() => {
    //                 setLoading(false); // 🔹 Har doim yakunda to‘xtatish
    //             });
    //     } else {
    //         toast.warning("Tasdiqlash kodini to'liq kiriting")
    //     }
    //
    // }

    return (
        <>
            <div className="ariza p-3" style={{border: "1px solid black"}}>
                <div className="d-flex justify-content-end">
                    <p className="fs-6 text-end w-50">
                       <b> Islom Karimov nomidagi Toshkent davlat texnika universiteti</b> Rektori, akademik
                        S.M.Turabdjanovga <span>{fulInfo?.departmentInfo?.name}</span>  <span> {fulInfo?.specialtyInfo?.name} yo'nalishi</span>
                        <span> {fulInfo?.groupInfo?.name}</span> talabasi
                        <b> {fulInfo?.fullName}</b>dan
                    </p>
                </div>
                <h3 className="text-center">Ariza</h3>
                <div style={{textAlign: "justify" ,textIndent: "30px"}}>
                    {/*<span style={{display: "inline-block", textIndent: "30px"}}>Men </span>*/}
                    {/*<b> {fulInfo?.fullName}</b>,*/}
                    {/*<span>{fulInfo?.departmentInfo?.name}</span>*/}
                    {/*<span> {fulInfo?.specialtyInfo?.name}</span>*/}
                    {/*<span> yo'nalishi</span>*/}
                    {/*<span> {fulInfo?.groupInfo?.name}</span>*/}
                    <span>
                           Men O‘zbekiston Respublikasi Vazirlar
                        Mahkamasining 2025-yil 10-martdagi 149-son
                        qarori bilan tasdiqlangan Nizom talablari asosida ta’lim grantlarini
                        tabaqalashtirilgan tartibda qayta taqsimlash tanlovida ishtirok
                        etishimga ruxsat berishingizni so‘rayman.
                </span>

                    <p>
                        Mazkur qaror bilan tanishganman va HEMIS platformasida GPA ko‘rsatkichim <b>{fulInfo?.avg_gpa} </b> ball
                        ekanligini tasdiqlayman. Tanlovga taqdim etilgan hujjatlar to‘plamining haqqoniyligini kafolatlayman.
                        Unda yolg‘on yoki soxta ma’lumot aniqlangani taqdirda, belgilangan tartibda javobgarlikka tortilishim mumkinligi haqida xabardorman.
                    </p>
                </div>
            </div>
            <div className="">{
                !verificatio ? <Form
                        form={form} layout="vertical" ref={formRef} colon={false}
                        onFinish={handleOk}
                    >
                        <Form.Item label="Murojaatchining telefon raqami" name="Tel" required={true}
                                   rules={[{required: true, message: 'Malumot kiritilishi shart !!!'}]}>
                            <Input ref={inputRef} maxLength={13} type="text" placeholder="+998(**) *** ** **"
                                   name="Tel"/>
                        </Form.Item>
                        <Form.Item>
                            <button className="btn btn-primary">
                                Yuborish
                            </button>
                        </Form.Item>
                    </Form> :
                    <Form form={form2} layout="vertical" ref={formRef} colon={false}>
                        <div className="otp">
                            <Form.Item label="Tasdiqlash kodini kiriting">
                                <OtpInput
                                    value={otp}
                                    onChange={setOtp}
                                    numInputs={6}
                                    placeholder={"******"}
                                    renderSeparator={<span>-</span>}
                                    renderInput={(props) => <input {...props} />}
                                />
                            </Form.Item>
                        </div>
                        <Button type="primary" onClick={verificationPost} loading={loading}>{loading ? "Yuklanmoqda" : "Tasdiqlash"}</Button>
                    </Form>
            }
            </div>
        </>
    );
}

export default ModalForma;